import React, { useState } from 'react';
import { motion } from 'framer-motion';
const PURCHASE_URL = 'https://creatinadesdecero.com/checkouts/cn/hWNAvfp4CaM7X6fdTqgOuFiT/es-ar?_r=AQAByQrvKKRvNL4yOlwASBJc3aRvs1RDUduK9RlYs9H7pb0&preview_theme_id=176488644801';
interface CTAButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  size?: 'default' | 'large';
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  size = 'default',
  href = PURCHASE_URL
}: CTAButtonProps) {
  const [isHovered, setIsHovered] = useState(false);
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} className={`block w-full max-w-xl mx-auto cursor-pointer no-underline transition-all duration-300 ${isHovered ? 'scale-[1.02]' : 'scale-100'} ${className}`} aria-label="Plan Básico - Acceder al manual" data-id="element-52">
      {/* Prompt text + bouncing arrow */}
      <div className="flex flex-col items-center mb-3" data-id="element-53">
        <p className="text-[#FFE600] text-sm sm:text-base font-bold text-center" data-id="element-54">
          Hacé clic en el botón y aprovechá el descuento por lanzamiento
        </p>
        <motion.span animate={{
        y: [0, 6, 0]
      }} transition={{
        duration: 1.2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-[#FFE600] text-2xl mt-1" data-id="element-55">
          ↓
        </motion.span>
      </div>

      <div className={`relative bg-gradient-to-r from-[#f5f3ef] to-[#edeae4] rounded-2xl px-5 sm:px-7 py-5 sm:py-6 border-2 transition-all duration-300 shadow-md ${isHovered ? 'border-[#2F6BFF] shadow-lg shadow-[#2F6BFF]/10' : 'border-[#e0ddd6] shadow-md'}`} data-id="element-56">
        {/* Top row: Radio + Plan info + Pricing (sm+) */}
        <div className="flex items-center gap-4 sm:gap-5" data-id="element-57">
          {/* Radio circle */}
          <div className={`flex-shrink-0 w-6 h-6 rounded-full border-2 transition-all duration-300 flex items-center justify-center ${isHovered ? 'border-[#2F6BFF]' : 'border-[#c5c0b6]'}`} data-id="element-58">
            <div className={`w-3 h-3 rounded-full transition-all duration-300 ${isHovered ? 'bg-[#2F6BFF] scale-100' : 'bg-transparent scale-0'}`} data-id="element-59" />
          </div>

          {/* Plan info */}
          <div className="flex-grow min-w-0" data-id="element-60">
            <div className="flex items-center gap-2 mb-0.5" data-id="element-61">
              <span className="text-lg" data-id="element-62">📘</span>
              <span className="text-[#1a1a1a] font-black text-sm sm:text-lg tracking-wide uppercase" data-id="element-63">
                PACK COMPLETO
              </span>
            </div>
            <span className="text-[#6b6560] text-xs sm:text-base font-medium" data-id="element-64">
              Manual + 4 bonos de REGALO 🎁
            </span>
          </div>

          {/* Pricing - visible on sm+ inline */}
          <div className="hidden sm:block flex-shrink-0 text-right" data-id="element-65">
            <div className="text-[#9b9590] text-base line-through font-medium" data-id="element-66">
              $128.900
            </div>
            <div className="text-[#1a1a1a] text-3xl font-black leading-none" data-id="element-67">
              $14.990
            </div>
          </div>
        </div>

        {/* Pricing - visible on mobile below */}
        <div className="flex sm:hidden items-center justify-center gap-3 mt-4 pt-4 border-t border-[#e0ddd6]" data-id="element-68">
          <span className="text-[#9b9590] text-sm line-through font-medium" data-id="element-69">
            $128.900
          </span>
          <span className="text-[#1a1a1a] text-2xl font-black leading-none" data-id="element-70">
            $14.990
          </span>
        </div>
      </div>
    </a>;
}